import clsx from 'clsx';

export const container = clsx(
  'px-10',
  'py-20',
  'md:px-48',
  'md:py-50',
  'bg-darkBackground',
  'flex',
  'flex-col',
  'md:flex-row',
  'justify-center',
  'items-center',
  'gap-20'
);

export const leftContainer = clsx(
  'md:w-[95%]',
  'md:items-start',
  'items-center',
  'flex',
  'flex-col'
);

export const rightContainer = clsx(
  'md:w-[100%]',
  'flex',
  'flex-col',
  'justify-center',
  'items-start',
  'gap-6'
);

export const rightInnerContainer = clsx(
  'flex',
  'flex-row',
  'justify-center',
  'items-center',
  'gap-6'
);

export const titleText = clsx(
  'title',
  'text-[26px]',
  'md:text-3xl',
  'font-medium',
  'mb-6',
  'text-title',
  'text-center',
  'md:text-left'
);

export const descriptionText = clsx(
  'font-subtitle',
  'text-[14px]',
  'md:text-[15px]',
  'text-description',
  'mb-4',
  'text-center',
  'md:text-left',
  'tracking-normal'
);

export const cardTitleText = clsx(
  'title',
  'text-[22px]',
  'md:text-2xl',
  'font-medium',
  'text-title',
  'text-left',
  'mb-1'
);

export const cardDescriptionText = clsx(
  'font-subtitle',
  'text-[14px]',
  'md:text-[15px]',
  'text-description',
  'md:text-left',
  'tracking-normal'
);

export const iconBackground = clsx(
  'rounded-md',
  'aspect-square',
  'bg-title',
  'h-12',
  'w-12',
  'flex',
  'justify-center',
  'items-center'
);

export const button = clsx(
  'title',
  'inline-flex',
  'flex-row',
  'items-center',
  'gap-1.5',
  'px-16',
  'py-4',
  'bg-title',
  'text-white',
  'text-sm',
  'font-regular',
  'rounded-full',
  'shadow',
  'hover:opacity-90',
  'w-auto',
  'mt-10'
);
